"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
var constants_1 = require("../../constants");
var isOneOfPages_1 = __importDefault(require("../isOneOfPages"));
function getMatchStatusesByLocation() {
    if (isOneOfPages_1.default(constants_1.pages.outright)) {
        return [
            types_1.GQL.SportEventStatus.NOT_STARTED,
            types_1.GQL.SportEventStatus.LIVE,
            types_1.GQL.SportEventStatus.SUSPENDED,
        ];
    }
    if (isOneOfPages_1.default(constants_1.pages.live)) {
        return [types_1.GQL.SportEventStatus.LIVE, types_1.GQL.SportEventStatus.SUSPENDED];
    }
    if (isOneOfPages_1.default(constants_1.pages.prematch, { exact: true })) {
        return [types_1.GQL.SportEventStatus.NOT_STARTED];
    }
    if (isOneOfPages_1.default(constants_1.pages.result, { exact: true })) {
        return [
            types_1.GQL.SportEventStatus.ENDED,
            types_1.GQL.SportEventStatus.LIVE,
            types_1.GQL.SportEventStatus.CLOSED,
        ];
    }
    return [
        types_1.GQL.SportEventStatus.NOT_STARTED,
        types_1.GQL.SportEventStatus.SUSPENDED,
        types_1.GQL.SportEventStatus.LIVE,
    ];
}
exports.default = getMatchStatusesByLocation;
//# sourceMappingURL=getMatchStatusesByLocation.js.map